import { Resource } from '@ngxp/rest';
import { ListResource } from '@schir-int-client/ngrx-helpers';
import { UserListLinkRel } from './user.linkrel';

export interface User {
	firstName: string;
	lastName: string;
	id: string;
	shortId: string;
	roles: UserRole[];
}

export interface UserResource extends User, Resource {}

export interface UserListResource extends ListResource<UserResource, UserListLinkRel.USER_LIST> {}

export enum UserRole {
	ADMIN = 'ADMINISTRATOR',
	RECHTSPFLEGER = 'RECHTSPFLEGER',
	GESCHAEFTSSTELLE = 'GESCHAEFTSSTELLE',
	DIENSTAUFSICHT = 'DIENSTAUFSICHT',
}
